/**
 * Must stay in sync with `supabase/functions/server/super-admin-emails.ts` (BUILTIN list).
 * Used so admin routes work even if `/user/role` is temporarily unavailable.
 */
const BUILTIN_SUPER_ADMIN_EMAILS = new Set(["jjj20092@gmail.com"]);

export function isSuperAdminEmailClient(email: string | undefined): boolean {
  if (!email?.trim()) return false;
  return BUILTIN_SUPER_ADMIN_EMAILS.has(email.trim().toLowerCase());
}
